import { TEAM_ACTIONS, TEAM_HIDDEN_FEATURES, TEAM_MODULE_ORDER, type TeamAction } from "@/lib/team/catalog";
import type { FeatureRow, PermissionFlags } from "@/lib/team/types";

export type MatrixCell = { action: TeamAction; applies: boolean; on: boolean };
export type MatrixRow = { feature: string; cells: MatrixCell[] };
export type MatrixGroup = { module: string; rows: MatrixRow[] };

export function buildMatrix(
  features: FeatureRow[],
  effective: Record<string, PermissionFlags>,
  activeModules: Set<string>,
): MatrixGroup[] {
  const order = TEAM_MODULE_ORDER as readonly string[];
  const groups = new Map<string, MatrixRow[]>();
  for (const feature of features) {
    if (TEAM_HIDDEN_FEATURES.has(feature.value) || feature.value === "vaccines") continue;
    if (!activeModules.has(feature.module)) continue;
    const flags = effective[feature.value];
    const row: MatrixRow = {
      feature: feature.value,
      cells: TEAM_ACTIONS.map((action) => {
        const applies = feature[`can_${action}` as const];
        return { action, applies, on: applies && !!flags?.[action] };
      }),
    };
    groups.set(feature.module, [...(groups.get(feature.module) ?? []), row]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) => (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99))
    .map(([module, rows]) => ({ module, rows }));
}
